import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output
} from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { RadioGroupFormControl } from './radio-group-form-control';

@Component({
  standalone: false,
  selector: 'app-radio-group-form-control',
  templateUrl: './radio-group-form-control.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioGroupFormControlComponent),
      multi: true
    }
  ]
})
export class RadioGroupFormControlComponent
  extends AbstractFormControlComponent<RadioGroupFormControl>
  implements ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  @Input() inline: boolean;
  @Output() onChanged: EventEmitter<boolean> = new EventEmitter();

  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  change(): void {
    this.onChanged.emit(this.control.value);
  }

  public get collection(): any[] {
    return this.control.collection || [];
  }

  public get keyPropertyName(): string {
    return this.control.keyPropertyName || 'name';
  }

  public get valuePropertyName(): string {
    return this.control.valuePropertyName || 'name';
  }

  public get isInline(): boolean {
    return this.inline || false;
  }
}
